import { render, staticRenderFns } from "./HRMessage.vue?vue&type=template&id=004be3a6&scoped=true"
import script from "./HRMessage.vue?vue&type=script&lang=js"
export * from "./HRMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004be3a6",
  null
  
)

export default component.exports